import React, { useRef, useEffect } from 'react';
import { useVendorContext } from '../../context/VendorContext';
import VendorHeader from '../Header/VendorHeader';
import MessageBubble from './MessageBubble';
import MessageInput from './MessageInput';
import EmptyState from '../EmptyState/EmptyState';
import './MessagePanel.css';

const MessagePanel = () => {
  const { selectedVendor, messages } = useVendorContext();
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, selectedVendor]);

  if (!selectedVendor) {
    return <EmptyState />;
  }

  const vendorMessages = messages[selectedVendor.id] || [];

  return (
    <div className="message-panel">
      <VendorHeader vendor={selectedVendor} />
      
      <div className="messages-container">
        {vendorMessages.map(message => (
          <MessageBubble key={message.id} message={message} />
        ))}
        <div ref={messagesEndRef} />
      </div>

      <MessageInput vendorId={selectedVendor.id} />
    </div>
  );
};

export default MessagePanel;